import React, { useEffect, useState } from "react";
import { getGalleries, getGallery } from "../lib/api";
import { Camera, X, ChevronLeft, ChevronRight } from "lucide-react";
import { SectionHeading } from "../components/ArticleCard";

export default function Galleries() {
  const [galleries, setGalleries] = useState([]);
  const [active, setActive] = useState(null);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    getGalleries().then(setGalleries).catch(() => {});
  }, []);

  const open = async (slug) => {
    const g = await getGallery(slug);
    setActive(g);
    setIdx(0);
  };

  const close = () => setActive(null);
  const next = () => active && setIdx((i) => (i + 1) % active.photos.length);
  const prev = () => active && setIdx((i) => (i - 1 + active.photos.length) % active.photos.length);

  return (
    <div className="paper-texture min-h-screen">
      <div className="border-b border-[var(--paper-border)] bg-[var(--navy)]">
        <div className="mx-auto max-w-7xl px-4 py-10">
          <p className="eyebrow flex items-center gap-2 text-[var(--gold)]"><Camera size={14} /> Visual Storytelling</p>
          <h1 className="font-display text-4xl font-extrabold text-white sm:text-5xl">Photo Galleries</h1>
          <p className="font-serif-body mt-2 text-white/80">Moments from across Amelia Island and Nassau County, captured by our newsroom.</p>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 py-10">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {galleries.map((g) => (
            <button
              key={g.slug}
              onClick={() => open(g.slug)}
              data-testid={`gallery-${g.slug}`}
              className="card-hover group text-left"
            >
              <div className="img-zoom relative overflow-hidden rounded-lg">
                <img src={g.cover} alt={g.title} className="h-64 w-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                <span className="eyebrow absolute left-3 top-3 flex items-center gap-1 rounded-full bg-black/50 px-2 py-1 text-[10px] text-white backdrop-blur">
                  <Camera size={11} /> {g.photos.length} photos
                </span>
                <div className="absolute inset-x-4 bottom-4 text-white">
                  <h3 className="font-display text-xl font-bold leading-snug">{g.title}</h3>
                  <p className="font-ui mt-1 text-xs text-white/80">Photos by {g.photographer}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {active && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/90 p-4" data-testid="gallery-lightbox" onClick={close}>
          <button className="absolute right-5 top-5 text-white/80 hover:text-white" onClick={close} data-testid="lightbox-close"><X size={28} /></button>
          <button className="absolute left-4 text-white/80 hover:text-white sm:left-10" onClick={(e) => { e.stopPropagation(); prev(); }} data-testid="lightbox-prev"><ChevronLeft size={40} /></button>
          <div className="max-w-4xl" onClick={(e) => e.stopPropagation()}>
            <img src={active.photos[idx].url} alt="" className="max-h-[75vh] w-full rounded object-contain" />
            <div className="mt-4 text-center">
              <p className="font-serif-body text-white">{active.photos[idx].caption}</p>
              <p className="font-ui mt-1 text-xs text-white/60">{active.title} · Photo {idx + 1} of {active.photos.length} · {active.photographer}</p>
            </div>
          </div>
          <button className="absolute right-4 text-white/80 hover:text-white sm:right-10" onClick={(e) => { e.stopPropagation(); next(); }} data-testid="lightbox-next"><ChevronRight size={40} /></button>
        </div>
      )}
    </div>
  );
}
